import { render, staticRenderFns } from "./Layout_GLYF_share.vue?vue&type=template&id=6da1bb42&scoped=true"
import script from "./Layout_GLYF_share.vue?vue&type=script&lang=js"
export * from "./Layout_GLYF_share.vue?vue&type=script&lang=js"
import style0 from "./Layout_GLYF_share.vue?vue&type=style&index=0&id=6da1bb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1bb42",
  null
  
)

export default component.exports